import React, { useState } from "react";
import PropTypes from 'prop-types';
import { UserAccess } from "components/user-access";
import { PageRestricted } from "pages/errors/page-restricted";
import { Tabs } from "components/navigation";
import { ShowHide } from "components/layout";
import { EmployeeLicenceBureauDetails } from "pages/employee/edit/licence-bureau/details";
import { EmployeeLicenceBureauCategories } from "pages/employee/edit/licence-bureau/categories";
import { EmployeeLicenceBureauEndorsements } from "pages/employee/edit/licence-bureau/endorsements";
import { EmployeeLicenceBureauAlerts } from "pages/employee/edit/licence-bureau/alerts";
import classNames from "classnames";

export function EmployeeLicenceBureau(
    {
        employeeOptions = null,
        licenceBureauAlertTypes = [],
        licenceCheck = null,
        loading = false,
        errorCode = 200,
        employeeId
    }
) {
    const noLicenceCheckCode = 404;
    const serviceNotAvailableCode = 500;

    const [currentTab, setCurrentTab] = useState(0);

    const requiredActions = ["LicenceCheck:LicenceBureau:View"];

    const [tabs, setTabs] = useState([
        { key: "DETAILS", title: "Details", selected: true },
        { key: "ENDORSEMENTS", title: "Endorsements" },
        { key: "CATEGORIES", title: "Categories" },
        { key: "ALERTS", title: "Alerts" }
    ]);

    function onTabClick(index) {

        var clonedTabs = [
            ...tabs
        ];

        clonedTabs = clonedTabs.map(function (t, i) {
            return {
                ...t,
                selected: index === i
            };
        });

        setTabs(clonedTabs);
        setCurrentTab(index);
    }


    function renderLicenceCheck() {
        if (errorCode === noLicenceCheckCode) {
            return <p>No matching employee record found in Licence Bureau (this could be due to an error with the licence number Vision has for this employee).</p>;
        } else if (errorCode === serviceNotAvailableCode) {
            return <p>Licence checking service is currently unavailable. Please try again.</p>;
        }

        const currentTabKey = tabs[currentTab].key;

        return (
            <div>
                <div className="spacer-bottom">
                    <div className="intro-text">
                        <p className={classNames({ "bp6-skeleton": loading })}>In this section you can view the licence information for the employee from Licence Bureau.</p>
                    </div>
                    <Tabs tabs={tabs} onClick={onTabClick} loading={loading} />
                    <ShowHide
                        evaluator={currentTabKey === 'DETAILS'}
                        show={(
                            <EmployeeLicenceBureauDetails licenceCheck={licenceCheck} loading={loading} />
                        )}
                    />

                    <ShowHide
                        evaluator={currentTabKey === 'ENDORSEMENTS'}
                        show={(
                            <EmployeeLicenceBureauEndorsements licenceCheck={licenceCheck} />
                        )}
                    />

                    <ShowHide
                        evaluator={currentTabKey === 'CATEGORIES'}
                        show={(
                            <EmployeeLicenceBureauCategories licenceCheck={licenceCheck} employeeOptions={employeeOptions} />
                        )}
                    />

                    <ShowHide
                        evaluator={currentTabKey === 'ALERTS'}
                        show={(
                            <EmployeeLicenceBureauAlerts employeeId={employeeId} licenceBureauAlertTypes={licenceBureauAlertTypes} />
                        )}
                    />
                </div>
            </div>
        );
    }

    return <UserAccess
        perform={requiredActions}
        yes={() => (
            <div className="row">
                <h2>Licence Checking</h2>
                {renderLicenceCheck()}
            </div>
        )}
        no={() => (
            <PageRestricted />
        )}
    />;
}

EmployeeLicenceBureau.propTypes = {
    employeeId: PropTypes.string.isRequired,
    employeeOptions: PropTypes.object,
    licenceBureauAlertTypes: PropTypes.array,
    licenceCheck: PropTypes.object,
    loading: PropTypes.bool,
    errorCode: PropTypes.number
};